// src/pages/SightseeingPage.js
import React, { useState } from 'react';
import { Container, Row, Col, Tab, Nav } from 'react-bootstrap';
import { TentTree, Car, BusFront } from 'lucide-react';

import SiteSeeingListPage from './SiteSeeingList';
import '../css/SightseeingPage.css'; // ✅ external stylesheet
import CabRentalListPage from './cabRental';

const CabAndRental = () => {
  const [activeTab, setActiveTab] = useState("sightseeing");

  return (
    <Container fluid className="mt-3 px-3 px-md-5 sightseeing-container">
      {/* Sticky Tab Bar */}
      <div className="sticky-tabbar">
        <Nav
          variant="pills"
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="d-flex justify-content-around text-center  flex-nowrap overflow-auto custom-tabs"
        >
          <Nav.Item className="flex-fill text-nowrap">
            <Nav.Link eventKey="sightseeing" className="tab-link ">
              <TentTree size={20} className="mb-1" />
              <br />
              <small>Sightseeing Rentals</small>
            </Nav.Link>
          </Nav.Item>

          <Nav.Item className="flex-fill text-nowrap">
            <Nav.Link eventKey="cab" className="tab-link">
              <Car size={20} className="mb-1" />
              <br />
              <small>Outstation Rentals</small>
            </Nav.Link>
          </Nav.Item>

          {/* Future Local Cab */}
          {/* <Nav.Item className="flex-fill text-nowrap">
            <Nav.Link eventKey="local" className="tab-link">
              <BusFront size={20} className="mb-1" />
              <br />
              <small>Local Cabs</small>
            </Nav.Link>
          </Nav.Item> */}
        </Nav>
      </div>

      {/* Content */}
      <Row className="mt-3">
        <Col xs={12}>
          <Tab.Container activeKey={activeTab}>
            <Tab.Content>
              <Tab.Pane eventKey="sightseeing">
                <SiteSeeingListPage />
              </Tab.Pane>
              <Tab.Pane eventKey="cab">
                {/* <CabRentalList /> */}
                <CabRentalListPage />
              </Tab.Pane>
              <Tab.Pane eventKey="local">
                {/* <LocalCabList /> */}
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </Col>
      </Row>
    </Container>
  );
};

export default CabAndRental;
